export type HttpMethod = 'GET' | 'POST' | 'PUT';

export enum HttpStatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  unprocessableEntity = 422,
  serverError = 500,
}

export type HttpResponse<T = any> = {
  body: T;
  status: HttpStatusCode;
};

export type HttpRequest<T = any> = {
  url: string;
  method: HttpMethod;
  data?: T;
  params?: Record<string, any>;
  headers?: Record<string, any>;
  useAuthorization?: boolean;
};

export type HttpRequestOptions = Omit<HttpRequest, 'url' | 'method' | 'data'>;
export type HttpRequestPostOptions = Omit<HttpRequestOptions, 'data'>;

export type HttpClient = {
  request: <T = any, D = any>(options: HttpRequest<D>) => Promise<HttpResponse<T>>;
  get: <T = any>(url: string, options?: HttpRequestOptions) => Promise<HttpResponse<T>>;
  post: <T = any, D = any>(url: string, data: D, options?: HttpRequestPostOptions) => Promise<HttpResponse<T>>;
  put: <T = any, D = any>(url: string, data: D, options?: HttpRequestPostOptions) => Promise<HttpResponse<T>>;
};
